Checkboxes = require './checkboxes'
DatePicker = require 'components/common/date_picker'
EditorText = require './editor_text'
GuidelineTags = require 'components/common/guideline_tags'
{ QuestionTags } = require 'components/common/question_tags'
IconInput = require 'components/covid_extraction_form/icon_input'
IconButton = require 'components/common/icon_button'
immutableUtils = require 'lib/immutable_utils'
InfoIconWithTooltip = require 'components/common/info_icon_with_tooltip'
mediator = require 'mediator'
MultipleInputs = require './multiple_inputs'
PercentInput = require 'components/common/percent_input'
CheckboxInput = require 'components/common/checkbox_input'
RadioInput = require 'components/common/radio_input'
RadioOptions = require './radio_options'
SelectCustom = require 'components/common/select_custom'
SelectWithOther = require './select_with_other'
SwitchableText = require 'components/common/switchable_text'
Switcher = require 'components/common/switcher'
StringField = require './string_field'
TextAreaField = require './textarea_field'
TextAreaWithApply = require 'components/common/text_area_with_apply'
{ SelectWithCheckboxes } = ReactComponents

showClearIcon = (showClear, value) ->
  return false unless showClear
  if Immutable.List.isList(value)
    not value.isEmpty()
  else
    _.isBoolean(value) or _.isNumber(value) or not _.isEmpty(value)

fieldShape =
  addValueLabel: PropTypes.string
  component: (props, propName) ->
    if props[propName] and not ReactIs.isValidElementType(props[propName])
      msg = 'Invalid prop "component" passed to extraction form:
             the prop is not a valid React component'
      new Error msg
  customWithArray: PropTypes.bool
  disabled: PropTypes.bool
  featureSwitch: PropTypes.string
  fieldKey: PropTypes.string.isRequired
  helperTextFromI18n: PropTypes.bool
  hide: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
  infoText: PropTypes.bool
  initialValue: PropTypes.any
  label: PropTypes.string
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string
        PropTypes.bool
        PropTypes.number
      ]).isRequired
      text: PropTypes.string
      textKey: PropTypes.string
    })
    PropTypes.string
  ]))
  noLabel: PropTypes.bool
  nameI18nKey: PropTypes.string
  parentValue: PropTypes.any
  parentValueKeys: PropTypes.arrayOf(PropTypes.string)
  placeholder: PropTypes.string
  placeholderFromI18n: PropTypes.bool
  readOnly: PropTypes.bool
  showClear: PropTypes.bool
  type: PropTypes.oneOf([
    'checkboxes'
    'checkboxToggle'
    'codes'
    'codesWithCheckboxes'
    'custom'
    'date'
    'editorText'
    'icon'
    'inputText'
    'multiSelect'
    'multiSelectWithOther'
    'multiText'
    'number'
    'percent'
    'questionsSelector'
    'questionTags'
    'radioOptions'
    'radioToggle'
    'select'
    'selectWithOther'
    'string'
    'switchableText'
    'switcher'
    'text'
    'textarea'
  ]).isRequired
  useControlledInput: PropTypes.bool
  withOther: PropTypes.bool

ExtractionFormField = createReactClass
  displayName: 'ExtractionFormField'

  propTypes: _.extend {}, fieldShape,
    additionalProps: PropTypes.object
    data: PropTypes.object
    className: PropTypes.string
    labelKey: PropTypes.string
    i18n: PropTypes.func.isRequired
    onChange: PropTypes.func.isRequired
    renderMode: PropTypes.oneOf(['regular', 'printout'])
    rightElement: PropTypes.node
    withAsterix: PropTypes.bool.isRequired
    value: PropTypes.oneOfType([
      PropTypes.instanceOf(Immutable.Map)
      PropTypes.instanceOf(Immutable.List)
      PropTypes.arrayOf(PropTypes.number)
      PropTypes.arrayOf(PropTypes.string)
      PropTypes.string
      PropTypes.bool
      PropTypes.object
    ])

  getDefaultProps: ->
    additionalProps: {}
    className: ""
    customWithArray: false
    disabled: false
    labelKey: null
    fill: true
    hide: false
    noLabel: false
    nameI18nKey: null
    parentValue: null
    parentValueKeys: []
    readOnly: false
    renderMode: 'regular'
    rightElement: null
    showClear: true
    data: {}

  onDateSave: (_e, newDate) ->
    @onChange newDate.toISOString()

  onChange: (newValue) ->
    { onChange, fieldKey } = @props
    onChange fieldKey, newValue

  onChangeMultiSelect: (key) -> (newValue) =>
    { value } = @props
    @onChange R.assoc key, newValue, if value? then value else {}

  onClear: ->

    { customWithArray, type } = @props
    newValue = switch type
      when 'inputText', 'text', 'date', 'editorText', 'string', 'textarea'
        ''
      when 'multiSelect', 'codes', 'multiText', 'checkboxes', 'multiSelectWithOther'
        []
      when 'percent'
        0
      when 'switchableText'
        {}
      when 'custom'
        if customWithArray then [] else {}
      else
        null

    @onChange newValue

  toggleSwitcher: ->
    { value } = @props
    @onChange not value

  render: ->
    {
      addValueLabel
      additionalProps
      className
      component: Component
      data
      disabled
      featureSwitch
      hide
      fieldKey
      fill
      helperTextFromI18n
      i18n
      infoText
      initialValue
      labelKey
      nameI18nKey
      noLabel
      options
      parentValue
      placeholder
      placeholderFromI18n
      readOnly
      renderMode
      rightElement
      showClear
      type
      value
      withAsterix
      withOther
      useControlledInput
    } = @props

    hideField = if _.isFunction(hide) then hide() else hide
    return null if hideField
    return null if featureSwitch? and not mediator.services.switches.isOn(featureSwitch)

    <div className="extraction-field #{fieldKey} #{if fill then 'w-full' else ''} #{className}">
      {!noLabel && <div className="extraction-field__name">
        {infoText and <InfoIconWithTooltip info={i18n "infoTexts.#{fieldKey}"} />}
        {i18n nameI18nKey or "fields.#{labelKey or fieldKey}"}{withAsterix and "*"}
      </div>}
      <div className={"extraction-field__value #{type}"}>
        <div>
          {switch type
            when 'icon'
              <IconInput 
                value={value}
                onChange={@onChange}
                readOnly={readOnly}
              />
            when 'inputText'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              <input 
                type="text"
                onChange={(e) => @onChange(e.target.value)}
                disabled={readOnly}
                placeholder={placeholderToUse}
                value={value or ''}
              />
            when 'textarea'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              <TextAreaField
                onChange={@onChange}
                disabled={readOnly}
                placeholder={placeholderToUse}
                value={value}
                autosize
              />
            when 'text'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              textarea = <TextAreaWithApply
                readOnly={readOnly}
                onApply={@onChange}
                content={value}
                placeholder={placeholderToUse}
              />
              if helperTextFromI18n
                <div className="text-with-helper">
                  <div className="helper-text">{i18n "helperTexts.#{fieldKey}"}</div>
                  <div>{textarea}</div>
                </div>
              else
                textarea
            when 'editorText'
              <EditorText readOnly={readOnly} onSave={@onChange} value={value} />
            when 'multiText'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              valueToPass = if not value?
                []
              else if Immutable.List.isList(value)
                value.toJS()
              else
                value

              if renderMode is 'printout'
                value?.join(', ')
              else
                <MultipleInputs
                  value={valueToPass}
                  initialValue={initialValue}
                  onApply={@onChange}
                  addValueLabel={addValueLabel}
                  placeholder={placeholderToUse}
                />
            when 'date'
              valueToPass = if (value and value isnt 'not_reported')
                moment(value).format('DD-MM-YYYY')
              else
                ''

              <div className="flex items-center">
                {fieldKey is 'latestLiteratureSearchDate' and <label className="mr-10">
                    <input
                      className="mr-5"
                      type="checkbox"
                      onChange={() =>
                        @onChange(if value is 'not_reported' then '' else 'not_reported')
                      }
                      disabled={readOnly}
                      checked={value is 'not_reported'}
                    />
                    {i18n "not_reported"}
                  </label>
                }
                {value isnt 'not_reported' and
                  <DatePicker
                    placeholder='dd-mm-yyyy'
                    value={valueToPass}
                    onSave={@onDateSave}
                  />
                }
              </div>
            when 'select'
              options = if _.isFunction(@props.filteredOptions)
                @props.filteredOptions(parentValue)
              else
                options
              <SelectCustom
                selected={value}
                disabled={readOnly}
                options={options}
                onChange={@onChange}
                optionsContainerWidthMode="fixed"
              />
            when 'selectWithOther'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              options = if _.isFunction(@props.filteredOptions)
                @props.filteredOptions(parentValue)
              else
                options
              <SelectWithOther
                onChange={@onChange}
                options={options}
                disabled={readOnly}
                placeholder={placeholderToUse}
                value={value}
              />
            when 'multiSelectWithOther'
              v = value['options'] if value?
              selectedOptions = if _.isNull(v) or _.isUndefined(v)
                []
              else if _.isString(v)
                [v]
              else v

              otherValue = value['other'] if value?

              if renderMode is 'printout'
                <div>{_.chain(selectedOptions)
                  .without('other')
                  .map((v) -> i18n "values.#{fieldKey}.#{v}")
                  .concat(otherValue)
                  .join(', ')
                  .value()}
                </div>
              else
                <React.Fragment>
                  <SelectWithCheckboxes
                    disabled={readOnly}
                    selectedOptions={selectedOptions}
                    options={options}
                    onChange={@onChangeMultiSelect('options')}
                    name={fieldKey}
                    withSelectAll={false}
                  />
                  {if 'other' in selectedOptions
                    <TextAreaWithApply
                      content={otherValue ? ''}
                      onApply={@onChangeMultiSelect('other')}
                    />}
                </React.Fragment>
            when 'multiSelect'
              selectedOptions = if _.isNull(value) or _.isUndefined(value)
                []
              else if _.isString(value)
                [value]
              else value

              if renderMode is 'printout'
                _.map(selectedOptions, (v) -> i18n "values.#{fieldKey}.#{v}").join(', ')
              else
                <SelectWithCheckboxes
                  disabled={readOnly}
                  selectedOptions={selectedOptions}
                  options={options}
                  onChange={@onChange}
                  name={fieldKey}
                  withSelectAll={false}
                />
            when 'radioOptions'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              <RadioOptions
                i18n={i18n}
                options={options}
                value={value}
                fieldKey={fieldKey}
                placeholder={placeholderToUse}
                helperTextFromI18n={helperTextFromI18n}
                withOther={withOther}
                onChange={@onChange}
              />
            when 'percent'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              <PercentInput
                i18n={i18n}
                value={value}
                fieldKey={fieldKey}
                placeholder={placeholderToUse}
                onChange={@onChange}
              />
            when 'switchableText'
              placeholderToUse = if placeholderFromI18n
                i18n "placeholders.#{fieldKey}"
              else
                placeholder ? ''
              <SwitchableText
                i18n={i18n}
                options={options}
                fieldKey={fieldKey}
                value={if immutableUtils.isImmutable(value) then value.toJS() else value}
                placeholder={placeholderToUse}
                onChange={@onChange}
              />
            when 'codes'
              codeGroup = switch fieldKey
                when 'guidelineInterventions' then 'intervention'
                when 'guidelinePopulations' then 'population'

              <div className='field' key={codeGroup}>
                <div className='field__label'>
                  {i18n "#{codeGroup}_code"}
                </div>
                <div className='field__text'>
                  <GuidelineTags
                    i18n={i18n}
                    fieldKey={fieldKey}
                    codeGroup={codeGroup}
                    onChange={@onChange}
                    tags={value}
                  />
                </div>
              </div>
            when 'codesWithCheckboxes'
              codeGroup = switch fieldKey
                when 'guidelineInterventions' then 'intervention'
                when 'guidelinePopulations' then 'population'
                else
                  fieldKey

              <div className='field' key={codeGroup}>
                {not additionalProps.hideLabel and <div className='field__label'>
                  {i18n "#{codeGroup}_code"}
                </div>}
                <div className='field__text'>
                  <GuidelineTags
                    readOnly={readOnly or disabled}
                    i18n={i18n}
                    fieldKey={fieldKey}
                    codeGroup={codeGroup}
                    onChange={@onChange}
                    tags={(value or options or [])}
                    withCheckboxes={true}
                  />
                </div>
              </div>
            when 'switcher'
              <Switcher
                checked={value}
                onChange={@toggleSwitcher}
              />
            when 'string', 'number'
              <StringField
                type={type}
                onChange={@onChange}
                {...additionalProps}
                disabled={readOnly or disabled}
                useControlledInput={useControlledInput}
                value={value}
              />
            when 'custom'
              if Component
                valueToPass = value || initialValue
                valueToPass = if immutableUtils.isImmutable valueToPass
                  valueToPass.toJS()
                else
                  valueToPass

                <Component
                  data={data}
                  field={fieldKey}
                  onChange={@onChange}
                  parentValue={parentValue}
                  value={valueToPass}
                  additionalProps={additionalProps}
                />
              else
                null
            when 'checkboxes'
              selectedOptions = if _.isNull(value) or _.isUndefined(value) or _.isBoolean(value)
                []
              else if _.isString(value)
                [value]
              else
                value

              <Checkboxes
                i18n={(optionKey) ->
                  if _.isEmpty(optionKey)
                    <span dangerouslySetInnerHTML={{__html: "&nbsp;"}} />
                  else
                    i18n "#{fieldKey}.#{optionKey}"
                }
                onChange={(selectedOptions) => @onChange selectedOptions}
                options={options}
                readOnly={readOnly}
                selectedOptions={selectedOptions}
              />
            when 'radioToggle'
              <RadioInput
                id={fieldKey}
                disabled={readOnly}
                checked={Boolean(value)}
                onClick={() => @onChange(not value)}
              />
            when 'checkboxToggle'
              <CheckboxInput
                id={fieldKey}
                disabled={readOnly}
                checked={Boolean(value)}
                onClick={() => @onChange(not value)}
              />
            when 'questionTags'
              <QuestionTags question={additionalProps.question} {...additionalProps.tagsProps} />
            else
              null
          }
        </div>
        {rightElement and <div className="extraction-field__right-element">{rightElement}</div>}
        {renderMode isnt 'printout' and showClearIcon(showClear, value) and <div className="clear-btn">
          <IconButton
            iconName="clear"
            onClick={@onClear}
          />
        </div>}
      </div>
    </div>

module.exports = { ExtractionFormField, fieldShape }
